<app-layout columnCount="2" vAlignment="middle">
  <app-layout-title>
    {{ 'RECOVERY.title' | translate }}
  </app-layout-title>
  <app-layout-content>
    <form (ngSubmit)="onRecovery()" [formGroup]="recoveryForm" class="grid">
      <mat-form-field>
        <mat-label>{{ 'RECOVERY.new_password_label' | translate }}</mat-label>
        <input #password="control"
          [placeholder]="'RECOVERY.new_password_placeholder' | translate"
          [type]="visiblePassword ? 'text' : 'password'"
          formControlName="newPassword"
          matInput>
        <button (click)="toggleVisible()" matSuffix mat-icon-button type="button">
          <mat-icon [color]="visiblePassword ? 'primary' : undefined">visibility</mat-icon>
        </button>
        @if (password.hasError('required')) {
          <mat-error>
            {{ 'VALIDATION.required' | translate }}
          </mat-error>
        }
        @if (password.hasError('minlength')) {
          <mat-error>
            {{ 'VALIDATION.invalid_password' | translate }}
          </mat-error>
        }
      </mat-form-field>
      <button color="primary" mat-raised-button type="submit">
        <mat-label>{{ 'RECOVERY.change_password' | translate }}</mat-label>
      </button>
    </form>
  </app-layout-content>
</app-layout>
